export default __webpack_public_path__ + "static/media/dayPassContainerImg.cc67d490.png";